import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_3 = { class: "col-lg-8 fv-row" }
const _hoisted_4 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_7 = { class: "col-lg-8 fv-row" }
const _hoisted_8 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_17 = {
  key: 1,
  class: "row"
}
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_21 = {
  key: 2,
  class: "row"
}
const _hoisted_22 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_29 = {
  key: 3,
  class: "row"
}
const _hoisted_30 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "col-lg-8 fv-row" }
const _hoisted_32 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_33 = {
  key: 4,
  class: "row"
}
const _hoisted_34 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_37 = {
  key: 5,
  class: "row"
}
const _hoisted_38 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_41 = { class: "col-form-label fw-normal fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.tratamiento.text), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.menorData.nombre + " " + _ctx.menorData.apellidos), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.fechaNacimiento.label")), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.formatDate(_ctx.menorData.fechaNacimiento)), 1)
      ])
    ]),
    (_ctx.menoresSimple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.servicio.label")), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.servicioProgramado.nombre), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.menoresSimple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.servicioDescripcion.label")), 1),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.servicioProgramado.descripcion), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.menoresSimple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.lugarPrestacion.label")), 1),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.lugarPrestacion), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccion.label")), 1),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.direccion), 1)
      ])
    ]),
    (!_ctx.menoresSimple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.fechasPrevistas.label")), 1),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.formatDate(_ctx.menor.inicioPrevisto)) + " a " + _toDisplayString(_ctx.formatDate(_ctx.menor.finPrevisto)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.menoresSimple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.detalleNecesidades.label")), 1),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.menorData.detalleNecesidades), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.menoresSimple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.diasHoras.label")), 1),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("ul", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiemposFiltrados, (tiempo, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: "row"
                }, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.formatTiempo(tiempo)), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}